import difference from 'lodash/difference';
import { Environment } from '../../config';

type InventoryPostTenantsBodyDTO = {
  organizationId: string;
  enabledProducts: string[];
  hiddenProducts: string[];
  environment: Environment;
};

/**
 * Creates the body for the inventory post tenants list request.
 * @param organizationId - The organization id.
 * @param enabledProducts - The enabled products. If there are non-displayable products, we want to show only the displayable products, else we show all enabled products including the embedded ones.
 * @param disabledProducts - The disabled products. If there are non-displayable products, we want to show only the displayable products, else we show all enabled products including the embedded ones.
 * @param environment - The environment. (dev, staging, pre-production, production)
 */
export const createInventoryPostTenantsBodyDTO = ({
  organizationId,
  enabledProducts = [],
  hiddenProducts = [],
  environment,
}: InventoryPostTenantsBodyDTO) => {
  // If there are disabled products, we want to show only the displayable products, else we show all enabled products including the embedded ones.
  const products = hiddenProducts.length
    ? difference(enabledProducts, hiddenProducts)
    : enabledProducts;

  return {
    labels: {
      ProductCode: {
        operator: 'Include',
        values: [...products],
      },
      Environment: {
        operator: 'Include',
        values: [environment],
      },
    },
    state: 'Active',
    organizationId,
  };
};
